export default __webpack_public_path__ + "static/media/growth_selling.d48548f0.png";